<div class="help-chat">
    <header class="chat-header">
        <mat-icon class="chat-icon" aria-hidden="true">forum</mat-icon>
        <h2 id="help-chat-title">Ask LINQ AI</h2>
        <span class="spacer"></span>
        <button mat-icon-button type="button" (click)="chat.newChat()" [disabled]="chat.asking || !chat.messages.length" matTooltip="New chat" aria-label="Start a new chat">
            <mat-icon>add_comment</mat-icon>
        </button>
        <button mat-icon-button type="button" mat-dialog-close matTooltip="Close" aria-label="Close the chat">
            <mat-icon>close</mat-icon>
        </button>
    </header>

    <div class="messages" #scroller role="log" aria-live="polite" aria-labelledby="help-chat-title">
        @if (!chat.messages.length) {
            <div class="intro">
                <p>Hi! Ask me anything about using LINQ: building models, insights, analysis, projects and more.</p>
                <div class="suggestions">
                    @for (s of suggestions; track s) {
                        <button mat-stroked-button type="button" (click)="ask(s)" [disabled]="chat.asking">{{s}}</button>
                    }
                </div>
            </div>
        }
        @for (m of chat.messages; track $index) {
            @if (m.role === 'user') {
                <div class="message user">{{m.content}}</div>
            }@else {
                <div class="message assistant" [innerHTML]="answerHtml(m)"></div>
            }
        }
        @if (chat.asking) {
            <div class="message assistant thinking" role="status">
                <span class="dot"></span><span class="dot"></span><span class="dot"></span>
                <span class="visually-hidden">LINQ AI is answering</span>
            </div>
        }
        @if (chat.error) {
            <div class="error" role="alert">
                {{chat.error}}
                <button mat-button type="button" color="accent" (click)="chat.retry()">Try again</button>
            </div>
        }
    </div>

    <!-- the native submit is handled here: without Angular's template forms there's no ngSubmit, and the browser would
         submit the form and reload the page -->
    <form class="composer" (submit)="$event.preventDefault(); send()">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="question">
            <mat-label>Ask a question</mat-label>
            <textarea matInput [formControl]="question" cdkTextareaAutosize cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5"
                [maxlength]="HELP_CHAT_MAX_CHARS" (keydown)="onKeydown($event)"></textarea>
        </mat-form-field>
        <button mat-icon-button type="submit" color="accent" [disabled]="chat.asking || !question.value.trim()" matTooltip="Send" aria-label="Send the question">
            <mat-icon>send</mat-icon>
        </button>
    </form>
    <p class="disclaimer">AI answers can be wrong. Check anything important in the guides, or ask support.</p>
</div>
